import { useQuery, useSubscription } from "@apollo/react-hooks";
import {
  MY_LEAVE_GET_REQUESTS_BY_CONTRACT,
  MY_LEAVE_REQUESTS_SUBSCRIPTION,
} from "my-leave/graphql";
import { useOcPolling } from "oc/hooks";

export const useMyLeaveUserRequests = ({
  contract,
}: {
  contract: string | null;
}) => {
  const year = new Date().getFullYear().toString();

  const { data, loading, error, refetch } = useQuery(
    MY_LEAVE_GET_REQUESTS_BY_CONTRACT,
    {
      skip: !contract || !year,
      variables: { contract, year },
      fetchPolicy: "cache-and-network",
      pollInterval: useOcPolling(1000 * 60),
    },
  );

  if (error) {
    console.log({
      component: "useUserLeaveRequests",
      errorDescription:
        "Error occured when fetch data with MY_LEAVE_GET_REQUESTS_BY_CONTRACT query",
      error: error,
    });
  }

  const { error: subscriptionError } = useSubscription(
    MY_LEAVE_REQUESTS_SUBSCRIPTION,
    {
      onData: () => {
        refetch();
      },
    },
  );

  if (subscriptionError) {
    console.log({
      component: "useUserLeaveRequests",
      errorDescription:
        "Error occured when subscribe data with MY_LEAVE_REQUESTS_SUBSCRIPTION query",
      error: error,
    });
  }

  let result = data?.leaveRequestsByContract || [];

  return { data: result, loading, error };
};

export default useMyLeaveUserRequests;
